import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux'
import store from "./redux/store/store";
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/flickity.css';
import './index.css';
import Router from './router/Router';

ReactDOM.render(
    <Provider store={store}>
        <Router />
    </Provider>,
  document.getElementById('app')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
